// eslint-disable-next-line import/no-cycle
import type { Fields } from "@vuex-orm/core";
import { BrowserPlayback } from "./ActionHierarchy";
import type { Timings } from "./ActionTypes";

export class Scroll extends BrowserPlayback {
  // This is the name used as module name of the Vuex Store.
  public static entity = "scrolls";

  public static baseEntity = "actions";

  public static fields(): Fields {
    return {
      ...super.fields(),
    };
  }

  public get duration(): number {
    return ((this.endsAt || 0) - (this.startsAt || 0)) / 1000;
  }

  public static get humanName(): string {
    return "Scroll";
  }

  // we probably want to build the descriptions in multiple steps:
  // 1. get the element description

  public verb = "scroll";

  public get prefix(): string {
    // fixme: find a better name than prefix
    if (this.isUnknownCategory) return "on";
    return "the";
  }

  // eslint-disable-next-line class-methods-use-this
  public get description(): string {
    return "Scroll";
  }
}
